import React, { Children } from 'react';
import type { FC, ReactNode } from 'react';

import { Box } from '@clutter/clean';

import { Block } from '@shared/page_builder/block';

export const SideBySide: FC<{
  children: ReactNode;
}> = ({ children }) => (
  <Block>
    <Box.Flex margin="0 auto" gap="24px" alignItems="center">
      {Children.map(children, (child, index) => (
        <Box.FlexItem flexGrow={1} flexShrink={1} flexBasis={1} key={index}>
          {child}
        </Box.FlexItem>
      ))}
    </Box.Flex>
  </Block>
);
